import { Platform } from "react-native";
import { createPlatformStyles, theme } from "../../theme/theme";
import { getCompanyName } from "@lib/utilities/Constants";
// Define your styles
export const { ids, styles } = createPlatformStyles({
  web: {
    actionTabContainer: { height: 380, width: "100%" },
    coverImage: {
      width: "100%",
      height: 380,
    },
    allCenter: { justifyContent: "center", alignItems: "center" },
    fullWidth: { width: "100%" },
    textHeading: {
      width: "80%",
      fontFamily: theme.fontFamily.robotoSlabBold,
      color: theme.colors.white,
      fontSize: theme.fontsize.lg,
      textAlign: "center",
      alignSelf: "center",
      fontWeight: theme.fontweight.bold,
      "@media (min-width: 485px)": {
        fontSize: theme.fontsize.xlg,
        width: "100%",
      },
      "@media (min-width: 600px)": {
        fontSize: theme.fontsize.xl,
        width: "100%",
      },
    },
    textSubHeading: {
      marginTop: theme.margin.reg,
      width: "80%",
      fontFamily: theme.fontFamily.robotoSlabMedium,
      color: theme.colors.white,
      fontSize: theme.fontsize.reg,
      alignSelf: "center",
      textAlign: "center",
      fontWeight: theme.fontweight.bold,
      "@media (min-width: 485px)": {
        fontSize: theme.fontsize.cs,
        width: "100%",
      },
      "@media (min-width: 600px)": {
        fontSize: theme.fontsize.mmd,
        width: "100%",
      },
    },
    bannerContainer: {
      top: "8%",
      width: "100%",
      zIndex: theme.zIndex.max,
    },
    brandingBackground: {
      width: "100%",
      height: 284,
      justifyContent: "center",
      alignItems: "center",
    },
    containerFluid: {
      position: "absolute",
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,

      backgroundColor: theme.colors.grayLighter,
      minWidth: "100%",

      height: "100%",
      width: "100%",
    },
    bgEffect: {
      backgroundColor: theme.colors.white,
      position: "absolute",
      "@media (min-width: 700px)": {
        top: -272,
        left: -101,
      },
      top: -527,
      // left: -101,
      transform: [{ rotate: "45deg" }],
      width: 400,
      height: 800,
    },
    viewContainer: {
      paddingTop: getCompanyName() == "CORE" ? 0 : 60,
    },
    bgEffectBottom: {
      backgroundColor: theme.colors.white,
      position: "absolute",
      bottom: -227,
      right: -101,
      transform: [{ rotate: "45deg" }],
      width: 400,
      height: 800,
      "@media (min-width: 200px)": {
        display: "none",
      },
      "@media (min-width: 700px)": {
        bottom: -472,
        right: -101,
      },
      "@media (min-width: 1150px)": {
        bottom: -472,
        right: -101,
      },
      "@media (min-width: 1281px)": {
        bottom: -472,
        right: -101,
      },
      "@media (min-width: 1441px)": {
        bottom: -472,
        right: -101,
      },
      "@media (min-width: 1681px)": {
        bottom: -472,
        right: -101,
      },
    },
    container: {
      maxWidth: "100%",
      width: "100%",
      backgroundColor: "transparent",
      display: "flex",
      flex: 1,
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      paddingTop: 60,
    },
    headerInfo: {
      position: "absolute",
      top: 0,
      width: "45%",
      ...Platform.select({
        web: {
          "@media (min-width: 200px)": {
            display: "none",
          },
          "@media (min-width: 600px)": {
            width: "50%",
          },
          "@media (min-width: 700px)": {
            display: "block",
            left: 36,
            width: "70%",
          },
          "@media (min-width: 800px)": {
            display: "block",
            left: 36,
            width: "50%",
          },
          "@media (min-width: 900px)": {
            width: "50s%",
            display: "block",
            left: 36,
          },
          "@media (min-width: 1100px)": {
            display: "block",
            left: 24,
          },
        },
      }),
    },
    policyActions: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      ...Platform.select({
        ios: {
          display: "flex",
          flex: 1,
          position: "absolute",
          top: 0,
          bottom: 0,
        },
        android: {
          display: "flex",
          flex: 1,
          top: 80,
        },
        web: {
          maxWidth: 1100,
          width: "100%",
          left: -4,
          marginLeft: "auto",
          marginRight: "auto",
        },
      }),
    },
    heading: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontWeight: theme.fontweight.bold,
      marginVertical: theme.margin.sm,
      color: theme.colors.text.primary,

      "@media (min-width: 200px)": {
        fontSize: theme.fontsize.xxl,
      },
      "@media (min-width: 600px)": {
        fontSize: theme.fontsize.xxl2,
      },
    },
    subHead: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontWeight: theme.fontweight.bold,
      width: 200,
      marginTop: theme.spacing.md,
      "@media (min-width: 200px)": {
        fontSize: theme.fontsize.mmd,
      },
      "@media (min-width: 600px)": {
        fontSize: theme.fontsize.lg,
      },
      "@media (min-width: 700px)": {
        width: 300,
      },

      color: theme.colors.text.secondary,
    },
    coreHeader: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontWeight: theme.fontweight.bold,
      // marginVertical: theme.margin.sm,
      color: theme.colors.white,
      fontSize: theme.fontsize.xl,
      textAlign: "center",

      // "@media (min-width: 200px)": {
      //   fontSize: theme.fontsize.xxl,
      // },
      // "@media (min-width: 600px)": {
      //   fontSize: theme.fontsize.xxl2,
      // },
    },
    coreSubHead: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontWeight: theme.fontweight.bold,
      fontSize: theme.fontsize.mmd,
      marginTop: theme.spacing.md,
      color: theme.colors.text.white,
      textAlign: "center",
      // "@media (min-width: 200px)": {
      //   fontSize: theme.fontsize.mmd,
      // },
      // "@media (min-width: 600px)": {
      //   fontSize: theme.fontsize.lg,
      // },
      // "@media (min-width: 700px)": {
      //   width: 300,
      // },
    },
  },
  mobile: {
    actionTabContainer: {
      width: "100%",
    },
    coverImage: {
      width: "100%",
    },
    allCenter: {
      justifyContent: "center",
      alignItems: "center",
    },
    fullWidth: { width: "100%" },
    textHeading: {
      width: "80%",
      fontFamily: theme.fontFamily.robotoSlabBold,
      color: theme.colors.white,
      fontSize: theme.fontsize.lg,
      textAlign: "center",
      alignSelf: "center",
      "@media (min-width: 485px)": {
        fontSize: theme.fontsize.xlg,
        width: "100%",
      },
      "@media (min-width: 600px)": {
        fontSize: theme.fontsize.xl,
        width: "100%",
      },
    },
    textSubHeading: {
      marginTop: theme.margin.reg,
      width: "60%",
      fontFamily: theme.fontFamily.robotoSlabMedium,
      color: theme.colors.white,
      fontSize: theme.fontsize.reg,
      alignSelf: "center",
      textAlign: "center",
      "@media (min-width: 485px)": {
        fontSize: theme.fontsize.cs,
        width: "80%",
      },
      "@media (min-width: 600px)": {
        fontSize: theme.fontsize.mmd,
        width: "80%",
      },
    },
    bannerContainer: {
      top: "8%",
      width: "100%",
      zIndex: theme.zIndex.max,
    },
    containerFluid: {
      overflow: "hidden",
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      backgroundColor: theme.colors.grayLighter,
      minWidth: "100%",
      ...Platform.select({
        ios: {
          display: "flex",
          width: "100%",
        },
        android: {
          display: "flex",
          width: "100%",
        },
      }),
    },
    viewContainer: {
      ...Platform.select({
        web: {
          paddingTop: 60,
        },
        android: {
          "@media (min-width: 385px)": {
            paddingTop: getCompanyName() == "CORE" ? 60 : 0, // tiles page padding top
          },
          "@media (min-width: 700px)": {
            paddingTop: 0,
          },
        },
      }),
    },
    bgEffect: {
      backgroundColor: theme.colors.white,
      position: "absolute",
      "@media (min-width: 700px)": {
        top: -272,
        left: -101,
      },
      top: -527,
      left: -101,
      transform: [{ rotate: "45deg" }],
      width: 400,
      height: 800,
    },

    bgEffectBottom: {
      backgroundColor: theme.colors.white,
      position: "absolute",
      bottom: -227,
      right: -101,
      transform: [{ rotate: "45deg" }],
      width: 400,
      height: 800,
      ...Platform.select({
        ios: {
          display: "none",
        },
        android: {
          display: "none",
        },
      }),
    },
    container: {
      maxWidth: "100%",
      width: "100%",
      backgroundColor: "transparent",
      display: "flex",
      height: theme.height,
      marginBottom:theme.spacing.xxxxl,
      top: "12%",
      bottom: 0,
      left: 0,
      right: 0,
    },
    policyActionTiles: {
      position: "relative",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      ...Platform.select({
        ios: {
          display: "flex",
          flex: 1,
          "@media (min-width: 200px)": {
            // iPhone 7, 8
            left: -120,
            top: 70,
          },
          "@media (min-width: 380px)": {
            // iPhone 11, 12
            left: -100,
            top: -30,
            transform: [{ scale: 0.9 }],
          },
          "@media (min-width: 420px)": {
            // iPhone 11, 12
            left: -90,
            top: 50,
          },
          "@media (min-width: 700px)": {
            position: "absolute",
            left: -120,
            top: 50,
          },
          "@media (min-width: 900px)": {
            // orientation: landscape for small iPad
            position: "absolute",
            left: -20,
            top: 50,
          },
          "@media (min-width: 1100px)": {
            position: "absolute",
            left: 0,
            top: 50,
          },
        },
        android: {
          "@media (min-width: 200px)": {
            // Android small devices
            top: -70,
            left: -115,
            transform: [{ scale: 0.9 }],
          },
          "@media (min-width: 385px)": {
            // Android large devices
            left: -90,
            transform: [{ scale: 0.9 }],
          },
          "@media (min-width: 485px)": {
            // Android small tablet
            left: -40,
            top: 70,
          },
          "@media (min-width: 700px)": {
            // Android medium (Galaxy S4) tablet
            position: "absolute",
            left: -90,
            // top: 40,
          },
          "@media (min-width: 900px)": {
            // Android large tablet
            position: "absolute",
            left: 130,
            top: -50,
          },
        },
      }),
    },

    headerInfo: {
      position: "absolute",
      top: 0,
      width: getCompanyName() == "TYPTAP" ? "45%" : "50%",
      ...Platform.select({
        ios: {
          "@media (min-width: 200px)": {
            display: "none",
          },
          "@media (min-width: 700px)": {
            display: "flex",
            left: 36,
            marginTop: 20,
          },
          "@media (min-width: 900px)": {
            // display: "flex",

            left: 36,
            marginTop: 20,
          },
          "@media (min-width: 1100px)": {
            display: "flex",
            left: 36,
            marginTop: 20,
          },
        },
        android: {
          "@media (min-width: 200px)": {
            display: "none",
          },
          "@media (min-width: 700px)": {
            display: "flex",
            left: 36,
          },
          "@media (min-width: 900px)": {
            display: "flex",
          },
          "@media (min-width: 1100px)": {
            display: "flex",
          },
        },
      }),
    },
    policyActions: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      ...Platform.select({
        ios: {
          display: "flex",
          flex: 1,
          position: "absolute",
          top: 0,
          bottom: 0,
        },
        android: {
          display: "flex",
          flex: 1,
          top: 80,
        },
      }),
    },

    heading: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      marginVertical: theme.spacing.sm,
      color: theme.colors.text.primary,
      ...Platform.select({
        ios: {
          "@media (min-width: 200px)": {
            // iPhone 7, 8
            fontSize: 20,
          },
          "@media (min-width: 380px)": {
            // iPhone 11, 12
          },
          "@media (min-width: 700px)": {
            // iPad mini
            fontSize: 30,
          },
        },
        android: {
          "@media (min-width: 200px)": {},
          "@media (min-width: 385px)": {},
          "@media (min-width: 700px)": {
            fontSize: 30,
          },
          "@media (min-width: 900px)": {
            // Android tab
            fontSize: 30,
          },
          "@media (min-width: 1000px)": {
            fontSize: 30,
          },
          "@media (min-width: 1200px)": {
            fontSize: 30,
          },
        },
      }),
    },
    subHead: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      color: theme.colors.text.secondary,
      fontSize: theme.fontsize.md,
      width: 200,
      marginTop: theme.spacing.md,
      "@media (min-width: 700px)": {
        width: 300,
      },
    },
  },
});
